document.addEventListener('DOMContentLoaded', () => {
    const sidebar = document.querySelector('.sidebar');
    const sidebarToggle = document.getElementById('sidebarToggle');
    const workArea = document.querySelector('.work-area');

    if (!sidebar) return;

    function applySidebarState() {
        const isCollapsed = localStorage.getItem('sidebarCollapsed') === 'true';

        if (isCollapsed) {
            sidebar.classList.add('sidebar--collapsed');
        } else {
            sidebar.classList.remove('sidebar--collapsed');
        }
    }
    function toggleSidebar() {
        sidebar.classList.toggle('sidebar--collapsed');

        const isCollapsed = sidebar.classList.contains('sidebar--collapsed');
        localStorage.setItem('sidebarCollapsed', isCollapsed);
    }

    applySidebarState();

    if (sidebarToggle) {
        sidebarToggle.addEventListener('click', toggleSidebar);
    }
});
